export default {
  selectedTopic: {}
};
